import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useGetCallQuery } from "src/features/conversations/conversationApi";
import AiSummary from "src/features/conversation/AiSummary";
import AiEntities from "src/features/conversation/AiEntities";
import DetailsData from "src/features/conversation/DetailsData";
import SummaryTitle from "src/features/conversation/SummaryTitle";
import SummaryContent from "src/features/conversation/SummaryContent";
import ActionPointsTitle from "src/features/conversation/ActionPointsTitle";
import ActionPointsContent from "src/features/conversation/ActionPointsContent";
import AiSentimentAnalysis from "src/features/conversation/AiSentimentAnalysis";
const AiInsightsContent = () => {
    const { callId } = useParams();
    const { t } = useTranslation();
    const { data: { 
    // @ts-ignore
    summary, actionPoints, tag, entities, callAnalysis, sentimentAnalysis } = {}, } = useGetCallQuery(callId);
    const summaryText = (summary === null || summary === void 0 ? void 0 : summary.trim()) || '';
    return (_jsxs(_Fragment, { children: [sentimentAnalysis && _jsx(AiSentimentAnalysis, { sentiment: sentimentAnalysis.sentiment, suggestion: sentimentAnalysis.recommended_agent_response }), ((callAnalysis === null || callAnalysis === void 0 ? void 0 : callAnalysis.length) > 0) && _jsx(AiSummary, { callAnalysis: callAnalysis }), _jsx(AiEntities, { entities: entities }), _jsx(DetailsData, { title: t('Tag_'), text: tag }), _jsx(SummaryTitle, { text: summaryText }), _jsx(SummaryContent, { text: summaryText || '', disableLineClamp: !summaryText }), _jsx(ActionPointsTitle, { text: actionPoints }), _jsx(ActionPointsContent, { text: actionPoints, disableLineClamp: !summaryText })] }));
};
export default AiInsightsContent;
